module.exports = __webpack_public_path__ + "img/type15.1bb5830c.png";